import axios from 'axios'

const resetPasswordReset = (email: string) => {
  return axios.get(
    `/api/auth/request-password-reset?email=${encodeURIComponent(email)}`
  )
}

export default resetPasswordReset
